var throttle = require('lodash/throttle');

const stickyHeader = () => {

    const onIntersection = (entries) => {
        const y = entries[0].boundingClientRect.y;
        if (y < 0) {
            $('.sticky-header').addClass('sticky-header--collapsed');
        } else {
            $('.sticky-header').removeClass('sticky-header--collapsed');
        }
    };

    const options = {
        root: document,
        rootMargin: "0px",
        threshold: 1,
    }

    const observer = new IntersectionObserver(onIntersection, options);
    const stickyHeaderSentinel = document.querySelector('#sticky-header-sentinel')

    if (stickyHeaderSentinel ) {
        observer.observe(stickyHeaderSentinel);    
    }

    const DOWN = 'down';
    const UP = 'up';

    let lastScrollY = 0;
    let direction = null;
    const peekHeader = () => {
        if (window.scrollY < 120 && !$('.sticky-header').hasClass('sticky-header--collapsed')) {
            $('.sticky-header').removeClass('sticky-header--peeking');
            return;
        }
        if (direction !== UP && window.scrollY < lastScrollY-10) {
            // going up
            $('.sticky-header').addClass('sticky-header--peeking');
            
            direction = UP;
        } else if (direction !== DOWN && window.scrollY > lastScrollY + 10) {
            if (!$('.category-level-1').find('>.dropdown-menu').hasClass('show')) {
                // going down
                $('.sticky-header').removeClass('sticky-header--peeking');
                direction = DOWN;
            }
        }
        lastScrollY = window.scrollY;
    }

    $(window).on('scroll', throttle(function () {
        peekHeader();
    }, 120));

}

module.exports = {
    stickyHeader
}